<template>
  <th
    :class="classList"
    scope="col"
    :aria-label="header.name"
    @click="header.sortBy && handleSort()"
    @keydown.enter="header.sortBy && handleSort()"
  >
    <div class="st-table-header__container">
      <span class="st-table-header__container__title" aria-hidden="true">
        {{ header.name }}
      </span>

      <div
        v-if="header.sortBy"
        :class="[
          'st-table-header__container__sort',
          `st-table-header__container__sort--${sortingIconDirection}`,
        ]"
        role="button"
        tabindex="0"
        @click.stop="handleSort"
        @keydown.enter.stop="handleSort"
        :aria-label="`Sortera på ${
          sortOrder === 'asc' ? 'fallande' : 'stigande'
        }`"
      >
        <st-icon
          :name="icon"
          size="small"
          :icon-props="{ color: '#1E1B19' }"
          :aria-hidden="true"
          :style="
            isSorted
              ? sortOrder === 'desc'
                ? 'transform: rotate(180deg);'
                : 'transform: rotate(0deg);'
              : 'transform: rotate(90deg);'
          "
        />
      </div>
    </div>
  </th>
</template>

<script setup>
import { computed, ref } from "vue";
import StIcon from "../icon/Icon.vue";

const props = defineProps({
  header: {
    type: Object,
    required: true,
  },
  isSorted: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["sort"]);
const sortOrder = ref("desc");

const classList = computed(() => [
  "st-table-header",
  {
    "st-table-header--is-sortable": !!props.header.sortBy,
  },
]);

const handleSort = () => {
  if (!props.header.sortBy) {
    return;
  }

  sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
  emit("sort", props.header.sortBy, sortOrder.value);
};

const icon = computed(() => (props.isSorted ? "arrow-vertical" : "swap"));
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-table-header {
  user-select: none;
  @include set-breakpoint {
    padding: rem-calc(22);
  }
  &--is-sortable {
    cursor: pointer;
  }
  &__container {
    display: flex;

    &__title {
      color: var(--text-color-primary);
      font-weight: 600;
      word-break: break-all;
      font-size: rem-calc(16);
    }

    &__checkbox {
      margin: auto;
    }

    & > :not(:last-child) {
      margin-right: rem-calc(10);
    }

    &__sort {
      display: flex;
      justify-content: center;
      flex-direction: column;
      &:focus {
        outline: rem-calc(2) solid var(--border-color-quaternary);
      }

      .st-icon {
        display: flex;
      }

      &--unsorted {
        .st-icon {
          transform: rotate(90deg);
        }
      }

      &--asc {
        .st-icon {
          transform: rotate(180deg);
        }
      }

      &--desc {
        .st-icon {
          transform: rotate(0deg);
        }
      }
    }
  }
}
</style>
